<app-hero-image
  [title]="'Traffic'"
  [imageUrl]="environment.cloudFrontUrl + '/content/traffic/Traffic_1.jpg'"
></app-hero-image>
<div class="page-content-container">
  <h2 style="margin-top: 0">Traffic</h2>
  <p>
    One of the main reasons TDOT is proposing Choice Lanes along I-24 is to
    address increasing traffic congestion. The stretch of I-24 between I-40 and
    I-840 is the most congested corridor in Tennessee, with more than 174,000
    vehicles traveling the corridor daily and a total of 23,700 recorded crashes
    between 2019-2023. Congestion is only expected to increase in the future, so
    TDOT is looking for a solution to improve traffic conditions in addition to
    accelerating project delivery.
  </p>

  <h2>Traffic Conditions and Data</h2>
  <p>
    As part of the NEPA process, TDOT is also required to examine traffic
    conditions and provide detailed traffic data as part of the environmental
    process. The Project Team collects data to understand current traffic
    conditions and develop in-depth projections for traffic growth in the
    future. This data is critical in identifying the best possible solution to
    address traffic conditions along the I-24 corridor. Below you can see
    current and future traffic conditions for the I-24 corridor and the
    estimated time to travel the entire corridor during the AM and PM peak
    hours.
  </p>

  <h2>Traffic Congestion without and with Choice Lanes</h2>
  <p>
    As the region continues to grow, so will traffic congestion and travel
    times. The graphic below shows traffic projections in the year 2052 without
    the proposed Choice Lanes project or “no-build” option. The no-build option
    is included to have a baseline of conditions to compare against proposed
    improvements and understand potential improvements impacts on traffic.
    Without improvements, the stretch of I-24 between Nashville and Murfreesboro
    will see worsening traffic congestion and eventually gridlock in both
    directions during the peak hours. In 2032, with no improvements the
    estimated travel times in the westbound lanes of I-24 are estimated to be 60
    to 94 minutes in the AM peak hours and 52 to 67 minutes in the PM peak
    hours. In 2052, the travel times for the westbound lanes will increase to
    100 to 168 minutes in the AM peak hours and 70 to 86 minutes in the PM peak
    hours. This level of congestion in the corridor will have a regional impact
    on quality of life for all travelers as well as the regional economy. With
    the implementation of the proposed Choice Lanes project, the projected
    traffic congestion should vastly improve in the westbound general-purpose
    lanes and have an end-to-end corridor travel time of 29 to 44 minutes in the
    AM peak hours and 35 to 43 minutes in the PM peak hours compared to the
    no-build scenario. The westbound Choice Lanes would see an average travel
    time of 23 minutes in the AM and PM peak hours.
  </p>

  <div class="pdf-grid">
    <app-pdf-viewer
      [thumbnailUrl]="pdfDocuments[0].thumbnail"
      [pdfUrl]="pdfDocuments[0].url"
      [title]="pdfDocuments[0].title"
      containerId="adobe-dc-view-1"
    ></app-pdf-viewer>
    <app-pdf-viewer
      [thumbnailUrl]="pdfDocuments[1].thumbnail"
      [pdfUrl]="pdfDocuments[1].url"
      [title]="pdfDocuments[1].title"
      containerId="adobe-dc-view-2"
    ></app-pdf-viewer>
  </div>

  <app-call-out-box
    [content]="
      '<p>The next section of the virtual meeting discusses the design process and how the Project Team will select an alternative to present for public feedback.</p>'
    "
  ></app-call-out-box>
</div>
